import React from 'react';
import { Empty } from 'antd';
import { ErrorHandler, LoadingState, History } from '@common/components';
import { useQuery } from '@common/hooks';
import { SUPPLIER_HISTORY_QUERY } from '@institutions/graphql';

export function SuppliersManagementViewDrawerHistory({
  supplierId,
}: {
  supplierId: string;
}) {
  const { data, loading, error } = useQuery(SUPPLIER_HISTORY_QUERY, {
    variables: { id: supplierId },
  });

  if (loading) return <LoadingState />;

  if (error || !data) {
    return (
      <ErrorHandler log="SuppliersManagementViewDrawerHistory" error={error} />
    );
  }

  const history = data.supplier.history;

  return (
    <>
      {history.length > 0 ? (
        <History data={history} />
      ) : (
        <Empty description="No history yet" />
      )}
    </>
  );
}
